import { render, staticRenderFns } from "./CreateBigQuestion.vue?vue&type=template&id=046ec701&scoped=true&"
import script from "./CreateBigQuestion.vue?vue&type=script&lang=js&"
export * from "./CreateBigQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CreateBigQuestion.vue?vue&type=style&index=0&id=046ec701&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046ec701",
  null
  
)

export default component.exports